import { dateRegexp, DEFAULT_FIELD_ERROR } from './constants';
const isNotEmpty = (value) => Boolean(value?.trim());
const isMatchingRegexp = (value) => dateRegexp.test(value);
const notEarlierThanToday = (value) => {
    try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const [day, month, year] = value.split('.');
        const date = new Date(`${year}-${month}-${day}`);
        return date >= today;
    }
    catch (error) {
        return false;
    }
};
export const validateFlightDate = (value, compareTo) => {
    const validation = [
        {
            validator: isNotEmpty,
            message: DEFAULT_FIELD_ERROR,
        },
        {
            validator: isMatchingRegexp,
            message: 'Введите дату в формате ДД.ММ.ГГГГ',
        },
        {
            validator: notEarlierThanToday,
            message: 'Дата не может быть раньше текущей',
        },
    ];
    const error = validation.find(({ validator }) => !validator(value));
    if (error) {
        return { error: error.message };
    }
    if (compareTo && isMatchingRegexp(compareTo)) {
        try {
            const [dayFrom, monthFrom, yearFrom] = compareTo.split('.');
            const [dayTo, monthTo, yearTo] = value.split('.');
            const dateFrom = new Date(`${yearFrom}-${monthFrom}-${dayFrom}`);
            const dateTo = new Date(`${yearTo}-${monthTo}-${dayTo}`);
            if (dateTo < dateFrom) {
                return {
                    error: 'Дата прилёта не может быть раньше даты вылета',
                };
            }
        }
        catch (error) {
        }
    }
    return { error: null };
};
